import { Dispatch } from 'redux';

export const SET_ADULTS = 'FLIGHT_SET_ADULTS';
export const SET_CHILDREN = 'FLIGHT_SET_CHILDREN';
export const SET_INFANTS = 'FLIGHT_SET_INFANTS';

export const SET_CLASS = 'FLIGHT_SET_CLASS';

export const setAdultsAction =  (count: number) =>  (dispatch: Dispatch<any>) => {    
    dispatch({
        type: SET_ADULTS,
        count
    });
};

export const setChildrenAction =  (count: number) =>  (dispatch: Dispatch<any>) => {    
    dispatch({
        type: SET_CHILDREN,
        count
    });
};

export const setInfantsAction =  (count: number) =>  (dispatch: Dispatch<any>) => {    
    dispatch({
        type: SET_INFANTS,
        count
    });
};

export const setClassAction =  (sc: string) =>  (dispatch: Dispatch<any>) => {    
    dispatch({
        type: SET_CLASS,
        sc
    });
};



// WEBPACK FOOTER //
// ./src/actions/Flight/passengers.ts